import {
    PRIORITIES,
    SHOW_SAVE_TO_FOLDER,
    STORAGE_KEYS,
    CALLOUT_KEYS,
} from '../pdpRespNotificationConstants';
import {
    getSessionAndStorageData,
    saveToStorage,
    displayNotification,
} from '../../../utils/notificationHelpers';

const { SAVE_TO_FOLDER: SAVE_TO_FOLDER_PRIORITY } = PRIORITIES;
const { SAVE_TO_FOLDER: SAVE_TO_FOLDER_STORAGE_KEY } = STORAGE_KEYS;
const { SAVE_TO_FOLDER: SAVE_TO_FOLDER_CALLOUT_KEY } = CALLOUT_KEYS;
const browserStorage = getSessionAndStorageData(
    SAVE_TO_FOLDER_STORAGE_KEY,
    SAVE_TO_FOLDER_CALLOUT_KEY
);

export default {
    name: 'saveToFolderCallout',
    priority: SAVE_TO_FOLDER_PRIORITY,
    rule: () => Promise.resolve(displayNotification(browserStorage, SAVE_TO_FOLDER_CALLOUT_KEY)),
    action: () => dispatch => {
        saveToStorage(SAVE_TO_FOLDER_STORAGE_KEY, { type: SAVE_TO_FOLDER_CALLOUT_KEY });
        dispatch({
            type: SHOW_SAVE_TO_FOLDER,
        });
    },
};
